<physics-excellence></physics-excellence>
<physics-solver-features></physics-solver-features>
<!-- <build-your-journey></build-your-journey> -->
<app-science-behind-physics-solver></app-science-behind-physics-solver>
<!-- <professional-for-physics-solver></professional-for-physics-solver> -->